import { formatCalibrationNumber } from "./calibrationCheckAverages";

function sanitizeFilePart(value) {
  return String(value || "plantio-calibragem")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9._-]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 80);
}

function escapeCsvCell(value) {
  const str = value == null ? "" : String(value);
  if (/[",;\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function formatTimestamp(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString("pt-BR");
}

export function buildPlantingCalibrationSpreadsheetFileName({
  observationId,
  orderLabel,
}) {
  const date = new Date().toISOString().slice(0, 10);
  return `plantio_calibragem_${sanitizeFilePart(
    orderLabel || observationId || "os"
  )}_${date}.csv`;
}

export function buildPlantingCalibrationSpreadsheetCsvRows({ rows, t }) {
  const header = [
    "#",
    t("Data/Hora"),
    t("Operador"),
    t("Máquina"),
    t("Painel início"),
    t("Painel"),
    t("ha plantados"),
    t("Adubo (kg)"),
    t("Adubo kg/ha"),
    t("Alvo adubo"),
    t("Semente abastecida"),
    t("Unidade semente"),
    t("Semente mil/ha"),
    t("Alvo semente"),
    t("Sementes/m"),
    t("Inoculante (L)"),
    t("Inoculante L/ha"),
    t("Status"),
  ];

  const body = (rows || []).map((row, index) => [
    index + 1,
    formatTimestamp(row.timestamp),
    row.operatorName || "",
    row.machineName || "",
    formatCalibrationNumber(row.panelHectaresInitial, 1) || "",
    formatCalibrationNumber(row.panelHectares, 1) || "",
    formatCalibrationNumber(row.hectaresPlanted, 2) || "",
    formatCalibrationNumber(row.fertilizerKg, 1) || "",
    formatCalibrationNumber(row.fertilizerAppliedKgHa, 1) || "",
    formatCalibrationNumber(row.fertilizerTargetKgHa, 1) || "",
    formatCalibrationNumber(row.seedQuantity, 2) || "",
    row.seedUnit || "",
    formatCalibrationNumber(row.seedAppliedThousandPerHa, 1) || "",
    formatCalibrationNumber(row.seedTarget, 1) || "",
    formatCalibrationNumber(row.seedAppliedPerMeter, 2) || "",
    formatCalibrationNumber(row.inoculantL, 1) || "",
    formatCalibrationNumber(row.inoculantAppliedLHa, 1) || "",
    row.outsideTolerance ? t("Fora da tolerância") : t("Dentro"),
  ]);

  return [header].concat(body);
}

export function downloadPlantingCalibrationSpreadsheetCsv(rows, fileName) {
  const csv = rows.map((row) => row.map(escapeCsvCell).join(";")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
